import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MapV2IframeBar = (props: Props): JSX.Element => {
    const ctxMapV2 = useContext(CtxMapV2);

    return (
        <S_MapV2IframeBar className={props.className}>
            <S_Fullscreen
                onClick={() => {
                    ctxMapV2.fullscreen.toggle();
                }}
            >
                <S_Text>
                    {ctxMapV2.fullscreen.isFullscreen
                        ? Localization.MAP_V2_FULLSCREEN_TURN_OFF
                        : Localization.MAP_V2_FULLSCREEN_TURN_ON}
                </S_Text>
                <S_Icon
                    icon={[
                        'far',
                        ctxMapV2.fullscreen.isFullscreen
                            ? 'down-left-and-up-right-to-center'
                            : 'up-right-and-down-left-from-center'
                    ]}
                />
            </S_Fullscreen>
        </S_MapV2IframeBar>
    );
};

const S_MapV2IframeBar = styled.div`
    background-color: #3c3c3c;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 35px;
    z-index: 4;
    padding: 0px 15px;
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: #fff;
`;

const S_Text = styled.div`
    color: #fff;
    font-family: ${EFonts.InterSemiBold};
    font-size: 14px;
`;

const S_Fullscreen = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 15px;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    cursor: pointer;
    &:hover {
        ${S_Text}, ${S_Icon} {
            color: #fffde7;
        }
    }
`;
